import React, { memo } from 'react';

import Chart from 'react-apexcharts';

import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import classes from 'components/common/charts/lineChart/lineChart.module.scss';

interface Props {
    options: ApexCharts.ApexOptions;
    series: ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
    isFetching?: boolean;
    noData?: React.ReactNode;
    height?: number | string;
    className?: string;
}

export const LineChart = memo(
    ({ isFetching = false, noData = undefined, options, series, height = 600, className = '' }: Props) => {
        return (
            <div className={`${classes.container} ${className}`}>
                {isFetching && <OverlayWithSpinner />}
                {noData}
                {!noData && <Chart options={options} series={series} type={'line'} height={height} />}
            </div>
        );
    },
);
